import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface HandoverDetailsSheetProps {
  open: boolean;
  onClose: () => void;
  dateLabel: string;
  isHandover: boolean;
  handoverType: string | null;
  handoverTime: string | null;
  handoverNote: string | null;
  onSave: (details: {
    is_handover: boolean;
    handover_type: string | null;
    handover_time: string | null;
    handover_note: string | null;
  }) => void;
  saving?: boolean;
}

export function HandoverDetailsSheet({
  open,
  onClose,
  dateLabel,
  isHandover,
  handoverType,
  handoverTime,
  handoverNote,
  onSave,
  saving,
}: HandoverDetailsSheetProps) {
  const [enabled, setEnabled] = useState(isHandover);
  const [type, setType] = useState(handoverType || "school");
  const [time, setTime] = useState(handoverTime || "");
  const [note, setNote] = useState(handoverNote || "");

  function handleSave() {
    onSave({
      is_handover: enabled,
      handover_type: enabled ? type : null,
      handover_time: enabled && time ? time : null,
      handover_note: enabled && note ? note : null,
    });
  }

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Overlevering</DialogTitle>
          <DialogDescription className="text-sm text-muted-foreground">
            {dateLabel}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-2">
          <div className="flex items-center justify-between">
            <label className="text-sm font-medium">
              Overlevering denne dagen
            </label>
            <Switch checked={enabled} onCheckedChange={setEnabled} />
          </div>

          {enabled && (
            <>
              <div className="space-y-1">
                <label className="text-xs text-muted-foreground">Type</label>
                <Select value={type} onValueChange={setType}>
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="school">Skolebytte</SelectItem>
                    <SelectItem value="other">Annet</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <div className="space-y-1">
                <label className="text-xs text-muted-foreground">
                  Tidspunkt
                </label>
                <Input
                  value={time}
                  onChange={(e) => setTime(e.target.value)}
                  placeholder="etter skole"
                />
              </div>

              <div className="space-y-1">
                <label className="text-xs text-muted-foreground">
                  Notat (valgfritt)
                </label>
                <Textarea
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  placeholder="SFO, trening…"
                  rows={2}
                />
              </div>
            </>
          )}
        </div>

        <DialogFooter className="flex gap-2">
          <Button variant="outline" onClick={onClose}>
            Avbryt
          </Button>
          <Button onClick={handleSave} disabled={saving}>
            {saving ? "Lagrer…" : "Lagre"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
